import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export function EditTxDialog({ tx, open, onClose, onSave }) {
  const [form, setForm] = useState({ concept: "", amount: "", date: "" });

  useEffect(() => {
    if (tx) setForm({ concept: tx.concept || "", amount: tx.amount ?? "", date: tx.date || "" });
  }, [tx]);

  if (!tx) return null;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="tx-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading">Editar movimiento</DialogTitle>
          <DialogDescription>Solo movimientos pendientes o ignorados. Los conciliados no se pueden modificar.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label className="text-xs">Fecha</Label>
            <Input data-testid="tx-edit-date" type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} className="h-9" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Concepto</Label>
            <Input data-testid="tx-edit-concept" value={form.concept} onChange={(e) => setForm({ ...form, concept: e.target.value })} className="h-9" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs">Importe (€) — negativo = gasto, positivo = ingreso</Label>
            <Input data-testid="tx-edit-amount" type="number" step="0.01" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} className="h-9 font-num" />
          </div>
          <Button data-testid="tx-edit-save" className="w-full bg-[#D9381E] hover:bg-[#B91C1C] text-white"
            disabled={!form.concept || !form.amount || !form.date}
            onClick={() => onSave({ concept: form.concept, amount: Number(form.amount), date: form.date })}>
            Guardar cambios
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
